import { Component } from "react";
import { logController } from "../../../controllers/log.controller";
import { prijemBalikaController } from "../../../controllers/prijembalika.controller";
import { LogLevel, MessageTypeEnum } from "../../../enums";
import { Zvuky } from "../Zvuky";

/**
 * Komponenta pro přidání artiklu do příjmu balíku na základě naskenovaného čárového kódu
 *
 * @class GetPrijemArtikelFromCiarovyKod
 * @extends {Component}
 */
class GetPrijemArtikelFromCiarovyKod extends Component {
    componentDidMount() {
        var pokracovat = (this.props.skenProgress != true);
        if (pokracovat && this.props.startRequest) {
            pokracovat = this.props.startRequest(); // Nastavit začátek skenování (zobrazit loading spinner)
        } else {
            Zvuky.playChyba(); // Pokud již skenování probíhá, tak přehrát zvuk chyby a naskenovaný kód zahodit
        }
        if (pokracovat) {
            // Předat skenovaný kód na server a po návratu spustit metodu getArtikel
            prijemBalikaController.pridatKus(this.props.balik, this.props.cisloCiarovehoKodu).then((response) => {
                this.props.getArtikel(response);
            }).catch((error) => {
                logController.logMessage("GetPrijemArtikelFromCiarovyKod.componentDidMount: " + error, LogLevel.Error);
                this.props.getArtikel({
                    messageType: MessageTypeEnum.EXCLAMATION,
                    errorMessage: `Server vrátil chybu pri pridávaní kusu do balíka (čiarový kód: ${this.props.cisloCiarovehoKodu}, balík: ${this.props.balik.packing}). Chyba byla zaznamenána do logu.\n\nZkuste prosím naskenovat čiarový kód artikla znovu.`,
                    isError: true
                });
            });
        }
    }

    render() {
        return null;
    }
}

export default GetPrijemArtikelFromCiarovyKod;



// WEBPACK FOOTER //
// ./src/components/common/SnimanieCiarovehoKodu/GetPrijemArtikelFromCiarovyKod.js